import { useState } from 'react';
import cn from 'classnames';

import LdsIcon from '../LdsIcon/index.jsx';

export default function MobileTabButtons({
  activeTab,
  handleTabClick,
  tabLabels,
  groupId,
  forceMobile,
}) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const label = tabLabels.find((label) => label.tabId === activeTab).label;

  const toggleTabDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleDrawerBtnClick = (e, tabId) => {
    setDrawerOpen(false);
    handleTabClick(e, tabId);
  };

  return (
    <div
      className={cn(
        'lds-tab-drawer',
        {
          open: drawerOpen,
          'd-block': forceMobile,
        }
      )}
    >
      <button
        id={`mobile-tab-btn-${groupId}`}
        className="lds-button-clear-style tab-btn tab-drawer-btn active focus-3px"
        onClick={toggleTabDrawer}
        role="tab"
        aria-expanded={drawerOpen}
        aria-haspopup="listbox"
        aria-owns={`mobile-tab-list-${groupId}`}
        aria-controls={`mobile-tab-list-${groupId}`}
      >
        <span className="lds-tab-drawer-label" aria-label={label}>{label}</span>
        <LdsIcon name="CaretDown" decorative />
      </button>
      <div
        id={`mobile-tab-list-${groupId}`}
        className="lds-tab-drawer-dropdown lds-card"
        role="listbox"
      >
        {
          tabLabels.map((label) => (
            <button
              key={label.tabId}
              className={cn(
                'lds-button-clear-style',
                'drawer-btn',
                'focus',
                {
                  active: activeTab === label.tabId,
                }
              )}
              onClick={(e) => handleDrawerBtnClick(e, label.tabId)}
              role="option"
              aria-selected={activeTab === label.tabId}
              aria-controls={`tab-panel-${label.tabId}`}
            >
              {label.label}
            </button>
          ))
        }
      </div>
    </div>
  );
}
